export default function Footer() {
  return (
    <footer className="bg-gray-900 border-t border-gray-800">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-3 gap-8">
          {/* Logo and Description */}
          <div>
            <div className="flex items-center mb-4">
              <img
                src="https://static.readdy.ai/image/38b84c1503cd17b8f12bcbc9adbcc594/b96be048663291dd024fde8a91ef186c.png"
                alt="Laginestra Lawyers"
                className="h-10 w-auto"
              />
            </div>
            <p className="text-gray-400 leading-relaxed">
              Transparency and security in Social Security Law.
              Specialized service throughout Brazil.
            </p>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-semibold mb-4">Contact</h4>
            <div className="space-y-3 text-gray-400">
              <div className="flex items-start">
                <i className="ri-map-pin-line mr-2 text-[#b86846] mt-1"></i>
                <span className="text-sm">
                  Rua Desembargador Munhoz de Mello 3800, sala 1103<br />
                  Zona 1 - Centro, Umuarama - PR, 87501-190
                </span>
              </div>
              <div className="flex items-center">
                <i className="ri-phone-line mr-2 text-[#b86846]"></i>
                <span className="text-sm">(44) 98801-0206</span>
              </div>
              <div className="flex items-start">
                <i className="ri-time-line mr-2 text-[#b86846] mt-1"></i>
                <span className="text-sm">
                  Monday to Friday: 08:30–18:00
                </span>
              </div>
            </div>
          </div>

          {/* Legal Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Legal Information</h4>
            <div className="space-y-2">
              <a href="#" className="block text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">
                Privacy Policy
              </a>
              <a href="#" className="block text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">
                Terms of Use
              </a>
              <p className="text-gray-400 text-sm mt-4">
                CNPJ: 12.345.678/0001-90
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8">
          <p className="text-gray-400 text-sm text-center">
            © 2025 Laginestra Lawyers. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
